import { SxProps } from '@mui/material/styles';

export const priceRangeSX: SxProps = {
	boxShadow: 'rgba(0, 0, 0, 0.15) 0px 1px 1px 1px',
	background: 'white',
	borderRadius: '0px',
};
